import { render } from "./factory_stock_mail.vue?vue&type=template&id=32527748&scoped=true"
import script from "./factory_stock_mail.vue?vue&type=script&lang=js"
export * from "./factory_stock_mail.vue?vue&type=script&lang=js"

import "./factory_stock_mail.vue?vue&type=style&index=0&id=32527748&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32527748"]])

export default __exports__